import React, { useState } from 'react';
import { View } from 'react-native';
import { Image } from 'expo-image';
import { useTheme } from '@/context/ThemeContext';
import Icon from '@/components/Icon';

export default function BotHero({ agent, compact = false }) {
  const { colors } = useTheme();
  const [failedSource, setFailedSource] = useState(null);
  const size = compact ? 72 : 96;
  const source = agent.avatarPath;
  return (
    <View accessibilityRole="image" accessible accessibilityLabel={`${agent.name} avatar`}
      style={{ width: size, height: size, borderRadius: size / 4, overflow: 'hidden',
        alignSelf: 'center', alignItems: 'center', justifyContent: 'center', marginBottom: 20,
        backgroundColor: colors.solid_color_tertiary }}>
      {source && source !== failedSource ? (
        <Image source={{ uri: source }} contentFit="cover" accessible={false}
          style={{ width: size, height: size }} onError={() => setFailedSource(source)} />
      ) : <Icon name="robot" size={size / 2} color={colors.text_color_secondary} />}
    </View>
  );
}
